import React from 'react';
import { useRouteMatch } from 'react-router';
import { CallbackModuleRegistry } from './module-registry';

export const CallbackComponent = () => {
  const match: { params: { callback: string } } = useRouteMatch();
  return <CallbackModuleRegistry.Render type={match.params.callback} />
}